import {http} from '@/helpers/http-helper';

class CNAE {
    constructor(uuid, code, activity, previousActivity, active) {
        this.uuid = uuid;
        this.code = code;
        this.activity = activity;
        this.previousActivity = previousActivity;
        this.active = active;
    }
}

export const getCnaes = () => {
    return new Promise( (resolve, reject) => {

        const url = 'cnae';

        http.get(url)
            .then((response) => {
                if (response.status === 200) {
                    let cnaes = [];

                    response.data.forEach((cnae) => {
                        cnaes.push(new CNAE(
                            cnae.uuid,
                            cnae.code,
                            cnae.activity,
                            cnae.previousActivity,
                            cnae.active
                        ));
                    });

                    resolve(cnaes);
                }
                else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const deleteCnae = (cnaeId) => {
    return new Promise((resolve, reject) => {
        const url = 'cnae/' + cnaeId;
        http.delete(url)
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};


export const getPaginatedCnaes = (searchData) => {
    return new Promise( (resolve, reject) => {
        const url = 'cnae';

        http.post(url, {searchData: searchData})
            .then((response) => {
                if (response.status === 200) {
                    let cnaes = [];

                    response.data.cnaes.forEach((cnae) => {
                        cnaes.push(new CNAE(
                            cnae.uuid,
                            cnae.code,
                            cnae.activity,
                            cnae.previousActivity,
                            cnae.active
                        ));
                    });

                    resolve({
                        cnaes: cnaes,
                        count: response.data.count
                    });
                }
                else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};
